export const countries = [
  { name: "Afghanistan", dialCode: "+93" },
  { name: "Albania", dialCode: "+355" },
  { name: "Algeria", dialCode: "+213" },
  { name: "Argentina", dialCode: "+54" },
  { name: "Australia", dialCode: "+61" },
  { name: "Austria", dialCode: "+43" },
  { name: "Bangladesh", dialCode: "+880" },
  { name: "Belgium", dialCode: "+32" },
  { name: "Brazil", dialCode: "+55" },
  { name: "Canada", dialCode: "+1" },
  { name: "China", dialCode: "+86" },
  { name: "Denmark", dialCode: "+45" },
  { name: "Egypt", dialCode: "+20" },
  { name: "Ethiopia", dialCode: "+251" },
  { name: "Finland", dialCode: "+358" },
  { name: "France", dialCode: "+33" },
  { name: "Germany", dialCode: "+49" },
  { name: "Ghana", dialCode: "+233" },
  { name: "India", dialCode: "+91" },
  { name: "Indonesia", dialCode: "+62" },
  { name: "Ireland", dialCode: "+353" },
  { name: "Italy", dialCode: "+39" },
  { name: "Japan", dialCode: "+81" },
  { name: "Kenya", dialCode: "+254" },
  { name: "Malaysia", dialCode: "+60" },
  { name: "Mexico", dialCode: "+52" },
  { name: "Morocco", dialCode: "+212" },
  { name: "Netherlands", dialCode: "+31" },
  { name: "New Zealand", dialCode: "+64" },
  { name: "Nigeria", dialCode: "+234" },
  { name: "Norway", dialCode: "+47" },
  { name: "Pakistan", dialCode: "+92" },
  { name: "Poland", dialCode: "+48" },
  { name: "Portugal", dialCode: "+351" },
  { name: "Qatar", dialCode: "+974" },
  { name: "Saudi Arabia", dialCode: "+966" },
  { name: "Senegal", dialCode: "+221" },
  { name: "Singapore", dialCode: "+65" },
  { name: "South Africa", dialCode: "+27" },
  { name: "Spain", dialCode: "+34" },
  { name: "Sweden", dialCode: "+46" },
  { name: "Switzerland", dialCode: "+41" },
  { name: "Turkey", dialCode: "+90" },
  { name: "United Arab Emirates", dialCode: "+971" },
  { name: "United Kingdom", dialCode: "+44" },
  { name: "United States", dialCode: "+1" },
  { name: "Vietnam", dialCode: "+84" },
];
